import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {ADMIN_TIME_ZONE} from "../../utils/apiHeaders"
import {ICustomerCommonListParams, ICustomerCommonListResponse} from "./CustomerApiTypes"

export const customerApi = createApi({
    reducerPath: "customerApi",
    baseQuery,
    endpoints: (build) => ({
        getCustomersCommonList: build.query<IBasicResponse<ICustomerCommonListResponse>, ICustomerCommonListParams>({
            query: ({lang, query, page, size}) => ({
                url: "v1/customers/common-list",
                method: "POST",
                headers: {
                    "Accept-Language": lang,
                    "X-Time-Zone": ADMIN_TIME_ZONE
                },
                body: {
                    page,
                    size,
                    ...(query?.trim() ? {query: query.trim()} : {})
                }
            })
        })
    })
})

export const {useLazyGetCustomersCommonListQuery} = customerApi
